<template>
<div class="popup_overlay">
  <div class="custom_dialog_comp bg-white h-full" style="width:100%">
    <div class="cust_card_comp">
      <div class="rounded px-5 py-4 h-full bg-primary text-white heading-2 font-bold flex items-center justify-between">
        <div>
          <p class="">technology_stack</p>
        </div>
        <div>
          <button class="list_top_card_btn font-bold bg-gray-200 cta-text text-text1 py-2 px-4 mr-2 rounded-3xl" @click="closeDetails(false)">Discard</button>
          <button class="list_top_card_btn font-bold  bg-success cta-text text-white py-2 px-4 rounded-3xl" @click="saveData()">Save</button>
        </div>  
      </div>
  <div class="p-0 bg-white" >
    <div class="bg-white p-2">
      <div class="pt-2 px-1 grid grid-cols-2 gap-x-2">
        <div class="box bg-white h-full cust_card">
          <div>
            <div class="p-2 pb-0 grid grid-cols-12">
              <div class="box col-span-6 p-2 pb-0">
                <p class="label_css">heading</p>
                <textarea v-model="fieldJsonData.heading"
                :class="heading_err ? 'border border-error' : ''"
                class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                placeholder="heading"
                ></textarea>
                <p v-if="heading_err" class="text-error heading-6">heading is required</p>
              </div>
              <!-- <div class="box col-span-6 p-2 pb-0">
                <p class="label_css">description</p>
                <textarea v-model="fieldJsonData.description"
                class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                placeholder="description"
                ></textarea>
              </div> -->
            </div>
              <div  class="mt-4" style="border: 1px solid gray"></div> 
          </div>
          <div class="py-2 px-1 grid  gap-x-2">
            <p class="label_css pl-2 font-bold">tab_list</p>
           <div v-for="(data, index) in fieldJsonData.tab_list" :key="index" class="p-2 pb-0 grid grid-cols-12">
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">tab_heading</p>
                    <input v-model="data.tab_heading"
                    :class="data.tab_heading_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="heading"
                    >
                    <p v-if="data.tab_heading_err" class="text-error heading-6">tab_heading is required</p>
                </div>
                <!-- <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">tab_slug</p>
                    <textarea v-model="data.tab_slug"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="tab_slug"
                    ></textarea>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">comp_slug</p>
                    <input v-model="data.comp_slug"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="comp_slug"
                    >
                </div> -->
            <div class="py-2 px-1 col-span-12  gap-x-2 mt-4" style="border: 1px solid #ccc">
            <p class="label_css pl-2 font-bold">card_list</p>
           <div v-for="(cardData, cardIndex) in data.card_list" :key="cardIndex" class="p-2 pb-0 grid grid-cols-12">
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">heading</p>
                    <textarea v-model="cardData.heading"
                    :class="cardData.heading_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="heading"
                    ></textarea>
                    <p v-if="cardData.heading_err" class="text-error heading-6">heading is required</p>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">card_group_slug</p>
                    <input v-model="cardData.card_group_slug"
                    :class="cardData.card_group_slug_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="card_group_slug"
                    >
                    <p v-if="cardData.card_group_slug_err" class="text-error heading-6">card_group_slug is required</p>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">img_url</p>
                    <input v-model="cardData.img_url"
                    :class="cardData.img_url_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="img_url"
                    >
                    <p v-if="cardData.img_url_err" class="text-error heading-6">img_url is required</p>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">img_alt</p>
                    <input v-model="cardData.img_alt"
                    :class="cardData.img_alt_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="img_alt"
                    >
                    <p v-if="cardData.img_alt_err" class="text-error heading-6">img_alt is required</p>
                </div>
                <div class="box col-span-12 p-1 mt-3">
                <div class="flex justify-end">
                  <button v-if="cardIndex !== 0" class=" rounded-full h-8 w-8 bg-error  mr-1"
                    @click="removeCardDetails(cardIndex)"
                    >
                    <i class="fas fa-minus text-white heading-3"></i>
                  </button>
                  <button v-if="cardIndex === data.card_list.length - 1" class=" rounded-full h-8 w-8 bg-primary"
                  @click="addCardDetails(index)"
                    >
                    <i class="fas fa-plus text-white heading-3"></i>
                  </button>
                </div>
              </div>
                <div v-if="data.card_list.length - 1 !== index" class="mt-4 col-span-12" style="border: 1px solid gray; border-style: dashed"></div>
             </div>
          </div>
          <div class="box col-span-12 p-1 mt-3">
                <div class="flex justify-end">
                  <button v-if="index !== 0" class=" rounded-full h-8 w-8 bg-error  mr-1"
                    @click="removeTabDetails(index)"
                    >
                    <i class="fas fa-minus text-white heading-3"></i>
                  </button>
                  <button v-if="index === fieldJsonData.tab_list.length - 1" class=" rounded-full h-8 w-8 bg-primary"
                  @click="addTabDetails()"
                    >
                    <i class="fas fa-plus text-white heading-3"></i>
                  </button>
                </div>
              </div>
                <div v-if="fieldJsonData.tab_list.length - 1 !== index" class="mt-4 col-span-12" style="border: 1px solid gray; border-style: dashed"></div>
                <div v-else  class="mt-4 col-span-12" style="border: 1px solid gray"></div> 
             </div>
          </div>
          <!-- <div class="p-2 pb-5 text-right">
            <div>
              <button class="list_top_card_btn bg-gray-200 cta-text text-text1 py-2 px-4 mr-2 rounded-3xl">Discard</button>
              <button class="list_top_card_btn bg-primary cta-text text-white py-2 px-4 mr-2 rounded-3xl" @click="saveData()">Save</button>
            </div>  
          </div> -->
        </div>
        <div>
        <img style="padding: 1px"  class="box border-1 shadow-lg rounded-lg" :src="componentImageUrl" :alt="componentImageUrl" />
      </div>
      </div>
    </div>
  </div>
    </div>
  </div>
</div>
</template>
<script>
// import draggable from 'vuedraggable'
// import HRM from '@/View/CMS/api/HRM.js'
export default {
  components: {
    // draggable,
  },
  props: ['componentDetailsForEdit', 'fieldJsonData', 'componentImageUrl', 'componentId'],
  data () {
    return {
      desc_err: false,
      heading_err: false,
      isError: true,
      // fieldJsonData: {
      //   component_name: "fieldJsonData",
      //   heading: "",
      //   description: "",
      //   tab_list: [
      //       {
      //       comp_slug: "",
      //       comp_slug_err: false,
      //       description: null,
      //       heading: "",
      //       heading_err: false
      //       },
      //       {
      //       comp_slug: "",
      //       comp_slug_err: false,
      //       description: null,
      //       heading: "",
      //       heading_err: false
      //       },
      //       {
      //       comp_slug: "",
      //       comp_slug_err: false,
      //       description: null,
      //       heading: "",
      //       heading_err: false
      //       },
      //       {
      //       comp_slug: "",
      //       comp_slug_err: false,
      //       description: null,
      //       heading: "",
      //       heading_err: false
      //       },
      //       {
      //       comp_slug: "",
      //       comp_slug_err: false,
      //       description: null,
      //       heading: "",
      //       heading_err: false
      //       },
      //       {
      //       comp_slug: "",
      //       comp_slug_err: false,
      //       description: null,
      //       heading: "",
      //       heading_err: false
      //       }
      //   ],
      //   card_list: [
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       },
      //       {
      //       card_group_slug: "",
      //       card_group_slug_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false
      //       }
      //   ]
      // }
    }
  },
  created() {
    if (this.componentDetailsForEdit !== null) {
      console.log("componentDetailsForEdit!!!!!!!!!!!fieldJsonData", this.componentDetailsForEdit)
      this.fieldJsonData = this.componentDetailsForEdit
      console.log("this.fieldJsonData", this.fieldJsonData)
    }
  },
  mounted () {
  },
  watch: {
    fieldJsonData: {
      handler () {
        console.log('fieldJsonData 123', this.fieldJsonData)
        if (this.fieldJsonData.cta_text !== '') {
          this.cta_text_err = false
          this.isError = false
        }
        if (this.fieldJsonData.cta_url !== '') {
          this.cta_url_err = false
          this.isError = false
        }
        if (this.fieldJsonData.description !== '') {
          this.desc_err = false
          this.isError = false
        }
        if (this.fieldJsonData.heading !== '') {
          this.heading_err = false
          this.isError = false
        }
        for (let index = 0; index < this.fieldJsonData.tab_list.length; index++) {
          if (this.fieldJsonData.tab_list[index].tab_heading !== '') {
            this.fieldJsonData.tab_list[index].tab_heading_err = false
            this.isError = false
          }
        }
        for (let indexM = 0; indexM < this.fieldJsonData.tab_list.length; indexM++) {
         for (let index = 0; index < this.fieldJsonData.tab_list[indexM].card_list.length; index++) {
          if (this.fieldJsonData.tab_list[indexM].card_list[index].heading !== '') {
            this.fieldJsonData.tab_list[indexM].card_list[index].heading_err = false
            this.isError = false
          }
          if (this.fieldJsonData.tab_list[indexM].card_list[index].card_group_slug !== '') {
            this.fieldJsonData.tab_list[indexM].card_list[index].card_group_slug_err = false
            this.isError = false
          }
          if (this.fieldJsonData.tab_list[indexM].card_list[index].img_url !== '') {
            this.fieldJsonData.tab_list[indexM].card_list[index].img_url_err = false
            this.isError = false
          }
          if (this.fieldJsonData.tab_list[indexM].card_list[index].img_alt !== '') {
            this.fieldJsonData.tab_list[indexM].card_list[index].img_alt_err = false
            this.isError = false
          }
         }
        }
      },
      deep: true
    }
  },
  methods: {
    addTabDetails () {
      this.fieldJsonData.tab_list.push({
        card_list: [{
          card_group_slug: '',
          heading: '',
          img_alt: '',
          img_url: ''
        }],
        comp_slug: '',
        tab_heading: '',
        tab_heading_err: false,
        tab_slug: ''
      })
      console.log("addddddd", this.fieldJsonData.card_list);
    },
    removeTabDetails (index) {
      if (this.fieldJsonData.tab_list[index].tab_list.length !== 1) {
        this.fieldJsonData.tab_list[index].tab_list.splice(index, 1)
      }
      console.log("removeeeeeee", this.fieldJsonData.tab_list);
    },
    addCardDetails (cardIndex) {
      for (let index = 0; index < this.fieldJsonData.tab_list.length; index++) {
        if (cardIndex === index) {
          this.fieldJsonData.tab_list[cardIndex].card_list.push({
            card_group_slug: "",
            card_group_slug_err: false,
            heading: "",
            heading_err: false,
            img_alt: "",
            img_alt_err: false,
            img_url: "",
            img_url_err: false
          })
        }
      }
      console.log("addddddd", this.fieldJsonData.card_list);
    },
    removeCardDetails (index) {
      if (this.fieldJsonData.tab_list[index].card_list.length !== 1) {
        this.fieldJsonData.tab_list[index].card_list.splice(index, 1)
      }
    },
    saveData() {
      console.log("componentDetailsForEdit", this.componentDetailsForEdit)
      if (this.fieldJsonData.cta_text === '') {
        this.cta_text_err = true
        this.isError = true
      }
      if (this.fieldJsonData.cta_url === '') {
        this.cta_url_err = true
        this.isError = true
      }
      if (this.fieldJsonData.description === '') {
        this.desc_err = true
        this.isError = true
      }
      if (this.fieldJsonData.heading === '') {
        this.heading_err = true
        this.isError = true
      }
      for (let index = 0; index < this.fieldJsonData.tab_list.length; index++) {
          if (this.fieldJsonData.tab_list[index].tab_heading === '') {
            this.fieldJsonData.tab_list[index].tab_heading_err = true
            this.isError = true
          }
      }
      for (let indexM = 0; indexM < this.fieldJsonData.tab_list.length; indexM++) {
        for (let index = 0; index < this.fieldJsonData.tab_list[indexM].card_list.length; index++) {
            if (this.fieldJsonData.tab_list[indexM].card_list[index].heading === '') {
              this.fieldJsonData.tab_list[indexM].card_list[index].heading_err = true
              this.isError = true
            }
            if (this.fieldJsonData.tab_list[indexM].card_list[index].card_group_slug === '') {
              this.fieldJsonData.tab_list[indexM].card_list[index].card_group_slug_err = true
              this.isError = true
            }
            if (this.fieldJsonData.tab_list[indexM].card_list[index].img_url === '') {
              this.fieldJsonData.tab_list[indexM].card_list[index].img_url_err = true
              this.isError = true
            }
            if (this.fieldJsonData.tab_list[indexM].card_list[index].img_alt === '') {
              this.fieldJsonData.tab_list[indexM].card_list[index].img_alt_err = true
              this.isError = true
            }
        }
      }
      if (this.isError === false) {
        for (let index = 0; index < this.fieldJsonData.tab_list.length; index++) {
            delete this.fieldJsonData.tab_list[index].tab_heading_err
        }
        for (let indexM = 0; indexM < this.fieldJsonData.tab_list.length; indexM++) {
          for (let index = 0; index < this.fieldJsonData.tab_list[indexM].card_list.length; index++) {
              delete this.fieldJsonData.tab_list[indexM].card_list[index].heading_err
              delete this.fieldJsonData.tab_list[indexM].card_list[index].card_group_slug_err
              delete this.fieldJsonData.tab_list[indexM].card_list[index].img_url_err
              delete this.fieldJsonData.tab_list[indexM].card_list[index].img_alt_err
          }
        }
        this.$emit('objData', this.fieldJsonData)
        this.componentDetailsForEdit = null
        let compIdImage = {
          imageUrl: this.componentImageUrl,
          id: this.componentId
        }
        // this.$emit('imageData', this.componentImageUrl)
        this.$emit('compIdImage', compIdImage)
        this.$root.$emit('closeComponentDialog', true)
        console.log("this.fieldJsonData............", this.fieldJsonData)
      }
    },
    closeDetails () {
    this.$root.$emit('closeComponentDialog', true)
    },
  },
  beforeDestroy () {
  }
}
</script>
<style scoped>
/* .list_top_card_btn {
  width: 163px !important;
  margin-right: 15px !important;
} */

::placeholder {
  font-size: 16px;
}
</style>